angular.module('ihestiaCommonDirectives.apk', []);
